/*
 * @Date: 2025-04-06 20:23:47
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-11-03 12:43:48
 */
export function initRem() {
  const setRemBase = () => {
    const doc = document.documentElement;
    const width = doc.clientWidth;

    const isMobile = width <= 768;
    const designWidth = isMobile ? 402 : 1728;

    const remSize = (width / designWidth) * 1;
    doc.style.fontSize = remSize + "px";
  };

  window.addEventListener("resize", setRemBase);
  setRemBase();
}

export function pxToRem(px) {
  const remBase = parseFloat(
    getComputedStyle(document.documentElement).fontSize
  );
  return px / remBase;
}
